module.exports = __webpack_public_path__ + "static/img/page7-bg2.9c83fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page7-bg2.png
// module id = qO7M
// module chunks = 216